// eslint-disable-next-line no-restricted-imports -- This is okay, and required for this package
import 'simplebar/dist/simplebar.css';

import SimpleBar from 'simplebar-react';

// Re-exported rather than imported directly so the stylesheet above is pulled in
// exactly once, by anything that renders a scroll area.
export const Scrollbar = SimpleBar;
